import loadable from '@loadable/component';

const Header = loadable(
  () => import(/* webpackChunkName: "content-management-system-content-header" */ './Header')
);

export default Header;
